import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgDefault = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 16C0 8.458 0 4.686 2.343 2.343S8.458 0 16 0c7.543 0 11.314 0 13.657 2.343S32 8.458 32 16c0 7.543 0 11.314-2.343 13.657S23.543 32 16 32c-7.542 0-11.314 0-13.657-2.343S0 23.543 0 16z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 6.676c-6.107 0-10.71 4.037-10.71 8.629 0 2.948 1.86 5.635 4.846 7.216l.599.318-.073.674a6.016 6.016 0 0 1-.939 2.657 11.213 11.213 0 0 0 4.102-2.097l.323-.262.415.045c.47.05.95.077 1.437.077 6.107 0 10.71-4.037 10.71-8.628 0-4.592-4.603-8.629-10.71-8.629zM3.29 15.305C3.29 9.26 9.173 4.676 16 4.676c6.827 0 12.71 4.584 12.71 10.629 0 6.044-5.883 10.628-12.71 10.628-.419 0-.833-.017-1.242-.05-1.856 1.408-4.615 2.703-8.185 2.703l-.37-1.929c.704-.28 1.938-1.174 2.354-2.732-3.136-1.896-5.267-5.012-5.267-8.62z"
      fill="#007AFF"
    />
  </svg>
);
const Memo = memo(SvgDefault);
export default Memo;
